import React from "react";

import { checkForOverride } from "./helpers/theme";
import {
	ReplaceWithDataSource,
} from "./helpers/variable";

export default function H1({
	cue,
	text,
	baseTheme,
	baseThemeId,
	whitespace = "",
	styled = true
}) {

	return (
		<span
			style={{
				color: checkForOverride(baseTheme, null, null, "h2", "colour"),
				fontFamily: checkForOverride(baseTheme, null, null, "h2", "font"),
				fontWeight:
					checkForOverride(baseTheme, null, null, "h2", "bold") === true
						? "bold"
						: "normal",
				fontStyle:
					checkForOverride(baseTheme, null, null, "h2", "italic") === true
						? "italic"
						: "normal",
				textDecoration:
					checkForOverride(baseTheme, null, null, "h2", "underline") === true
						? "underline"
						: "none",
			}}
			className={`${whitespace} ${baseThemeId}_${
				cue.type
			}_small_text ${baseThemeId}_small_text small_text
						text-${checkForOverride(baseTheme, null, null, "h2", "size")}
						leading-${checkForOverride(baseTheme, null, null, "h2", "leading")}
                    `}
		>
			<ReplaceWithDataSource text={text} styled={styled} />
		</span>
	);
}
